module.exports = __webpack_public_path__ + "img/77adce0e140a2c1261fd10b3f706d40b.png";